import CreateUser from '../organisms/CreateUser';
import Layout from '../../../../layout/Layout';
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection';

export default function CreateUserPage() {
    return (
        <Layout>
            <HeaderPageSection title="Nuevo Usuario" showGoBack={true} />
            <div>
                <CreateUser />
            </div>
        </Layout>
    )
}
